var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCropRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1271 3C16.1271 3 13.3401 16.1996 20.2641 23.0696C24.0641 26.8421 30.6701 26.8593 33.1401 19.8776C40.5401 17.7894 40.8601 9.86905 36.0571 7.34162C30.6871 4.51532 25.0021 9.98172 16.1271 3Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3601 12.0879C57.3601 12.0879 59.8231 21.4385 55.1151 26.5755C52.5301 29.3971 47.8081 29.6243 45.7931 24.7108C40.4261 23.4571 39.9161 17.8035 43.2601 15.8404C47.0001 13.6443 51.2611 17.3719 57.3601 12.0879Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 56.8939C44.6288 54.3521 45.9508 51.1582 48.6718 51.1582",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1444 51.3154C48.9444 51.0624 50.2724 47.5811 54.1604 47.5811C58.0484 47.5811 62.6024 51.3154 65.1944 51.3154C67.7864 51.3154 55.4144 59.251 49.1444 51.3154Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7631 47.2106C37.3299 45.996 36.4986 44.9469 35.3921 44.2188C34.2857 43.4906 32.963 43.1221 31.6201 43.1679",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6201 43.1679C31.8201 42.9159 30.4921 39.4336 26.6051 39.4336C22.7181 39.4336 18.1621 43.1679 15.5701 43.1679C12.9781 43.1679 25.3511 51.1035 31.6201 43.1679Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2764 65.5747L33.4424 65.6148C37.944 66.6852 42.6518 66.6852 47.1534 65.6148L47.3194 65.5747C47.3194 65.5747 44.8194 61.2636 40.2974 32.8994C35.6104 61.2636 33.2764 65.5747 33.2764 65.5747Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56 19.6555C44.776 24.1614 40.291 32.8971 40.291 32.8971C40.291 32.8971 37.436 18.8067 24.623 14.3467",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 57C9.20959 63.8864 14.2453 69.699 20.5264 73.7675C26.8075 77.836 34.0782 79.9947 41.5 79.9947C48.9218 79.9947 56.1925 77.836 62.4736 73.7675C68.7547 69.699 73.7904 63.8864 77 57H6Z",
    fill: "#EDFAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7899 65.6119C35.1146 65.624 34.4485 65.454 33.8616 65.1197C33.2747 64.7853 32.7888 64.299 32.4549 63.7119C32.113 64.2928 31.6254 64.7743 31.0403 65.1088C30.4552 65.4433 29.7929 65.6193 29.1189 65.6193C28.4449 65.6193 27.7826 65.4433 27.1975 65.1088C26.6124 64.7743 26.1248 64.2928 25.7829 63.7119C25.4409 64.2925 24.9533 64.7738 24.3683 65.1082C23.7833 65.4426 23.1212 65.6185 22.4474 65.6185C21.7736 65.6185 21.1114 65.4426 20.5264 65.1082C19.9414 64.7738 19.4538 64.2925 19.1119 63.7119C18.778 64.2993 18.292 64.7858 17.7049 65.1202C17.1178 65.4546 16.4514 65.6244 15.7759 65.6119",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4758 68.4734C61.7998 68.4847 61.1333 68.3136 60.5462 67.9782C59.9592 67.6428 59.4734 67.1555 59.1398 66.5674C58.7977 67.1477 58.31 67.6288 57.725 67.963C57.1401 68.2972 56.478 68.473 55.8043 68.473C55.1306 68.473 54.4686 68.2972 53.8836 67.963C53.2986 67.6288 52.811 67.1477 52.4688 66.5674C52.1356 67.1558 51.6498 67.6433 51.0627 67.9788C50.4756 68.3142 49.8089 68.4851 49.1328 68.4734",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8191 74.6119C42.1436 74.624 41.4774 74.454 40.8904 74.1196C40.3034 73.7853 39.8172 73.299 39.4831 72.7119C39.1411 73.2925 38.6535 73.7738 38.0685 74.1082C37.4835 74.4426 36.8214 74.6185 36.1476 74.6185C35.4738 74.6185 34.8116 74.4426 34.2266 74.1082C33.6416 73.7738 33.154 73.2925 32.8121 72.7119C32.4781 73.2992 31.992 73.7856 31.4049 74.1199C30.8179 74.4543 30.1516 74.6242 29.4761 74.6119",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 58.2285H5",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCropRotation);
export default __webpack_public_path__ + "static/media/icon_crop_rotation.d433fde1b5c0dd9a5810e6ac03fa9b77.svg";
export { ForwardRef as ReactComponent };